<template>
  <div>
    <a-card title="配置管理">
      <a-spin :spinning="loading">
        <a-descriptions bordered>
          <a-descriptions-item label="激活入库" :span="3">
            <a-switch :checked="form.enable_auto_stock_in" :loading="saving" @change="(v) => onSwitchChange('enable_auto_stock_in', v)" />
            <Helper :message="'激活后无需到库存管理页面手动确认入库。'" style="margin-left:20px;"></Helper>
          </a-descriptions-item>
          <a-descriptions-item label="激活出库" :span="3">
            <a-switch :checked="form.enable_auto_stock_out" :loading="saving" @change="(v) => onSwitchChange('enable_auto_stock_out', v)" />
             <Helper :message="'激活后无需到库存管理页面手动确认出库。'" style="margin-left:20px;"></Helper>
          </a-descriptions-item>
        </a-descriptions>
      </a-spin>
    </a-card>
  </div>
</template>

<script>
  import { configInfo, configUpdate } from '@/api/system'

  export default {
    name: 'Config',
    components:{
       Helper: () => import("@/components/Helper/Helper"),
    },
    data() {
      return {
        loading: false,
        saving: false,
        form: {},
      };
    },
    methods: {
      initialize() {
        this.list();
      },
      list() {
        this.loading = true;
        configInfo().then(resp => {
          this.form = resp;
        }).catch(err => {
          this.$message.error((err && err.response && err.response.data && err.response.data.error) || '加载失败');
        }).finally(() => {
          this.loading = false;
        });
      },
      onSwitchChange(field, value) {
        if (this.saving) return;
        const prev = this.form[field];
        this.$set(this.form, field, value);
        this.saving = true;
        configUpdate(this.form).then(() => {
          this.$message.success('保存成功');
        }).catch(err => {
          this.$set(this.form, field, prev);
          this.$message.error((err && err.response && err.response.data && err.response.data.error) || '保存失败');
        }).finally(() => {
          this.saving = false;
        });
      }
    },
    mounted() {
      this.initialize();
    },
  }
</script>

<style scoped>
</style>